export default {
  'common.operation': 'Thao tác',
  'product.management.title': 'Quản lý sản phẩm',
  'product.management.add': 'Thêm sản phẩm',
  'product.management.edit': 'Chỉnh sửa sản phẩm',
  'product.management.delete': 'Xóa',
  'product.management.search': 'Tìm kiếm',
  'product.management.reset': 'Đặt lại',
  'product.management.name': 'Tên sản phẩm',
  'product.management.type': 'Loại sản phẩm',
  'product.management.status': 'Trạng thái',
  'product.management.currency': 'Tiền tệ',
  'product.management.value': 'Giá trị sản phẩm',
  'product.management.amount': 'Số lượng sản phẩm',
  'product.management.price': 'Điểm sản phẩm',
  'product.management.quantity': 'Số lượng sản phẩm',
  'product.management.limit': 'Giới hạn mua',
  'product.management.dailyLimit': 'Giới hạn mua hàng ngày',
  'product.management.vipLimit': 'Cấp giới hạn (VIP)',
  'product.management.vipLimitDisplay': 'VIP {{value}}',
  'product.management.vipPurchaseLimit': 'Giới hạn mua VIP',
  'product.management.vipPurchaseLimitCount': 'Số lần giới hạn mua',
  'product.management.vipPurchaseLimitEnabled': 'Đã bật',
  'product.management.vipLevel': 'VIP',
  'product.management.vipLimitZeroError': 'Giới hạn mua của cấp VIP đã bật không thể là 0',
  'product.management.sort': 'Sắp xếp',
  'product.management.flow': 'Dòng sản phẩm',
  'product.management.cash': 'Tiền mặt',
  'product.management.props': 'Đạo cụ',
  'product.management.propsCategory': 'Phân loại đạo cụ',
  'product.management.propsCategory.luckySpin': 'Vé vòng quay lớn',
  'product.management.propsCategory.fuel': 'Nhiên liệu',
  'product.management.propsCategory.treasureBoxKey': 'Chìa khóa Rương',
  'product.management.keyType': 'Loại chìa khóa',
  'product.management.keyType.WOOD': 'Chìa khóa Gỗ',
  'product.management.keyType.IRON': 'Chìa khóa Sắt',
  'product.management.keyType.BRONZE': 'Chìa khóa Đồng',
  'product.management.keyType.SILVER': 'Chìa khóa Bạc',
  'product.management.keyType.GOLD': 'Chìa khóa Vàng',
  'product.management.keyType.DIAMOND': 'Chìa khóa Kim Cương',
  'product.management.physical': 'Hàng hóa',
  'product.management.enable': 'Bật',
  'product.management.disable': 'Tắt',
  'product.management.success': 'Thành công',
  'product.management.fail': 'Thất bại',
  'product.management.confirmDelete': 'Bạn có chắc chắn muốn xóa?',
  'product.management.confirmEnable': 'Bạn có chắc chắn muốn bật?',
  'product.management.confirmDisable': 'Bạn có chắc chắn muốn tắt?',
  'product.management.operator': 'Người vận hành',
  'product.management.operateTime': 'Thời gian vận hành',
  'product.management.unknown': 'Không xác định',
  'product.management.unknownStatus': 'Trạng thái không xác định',
  'product.language.title': 'Quản lý ngôn ngữ',
  'product.language.add': 'Thêm ngôn ngữ',
  'product.language.edit': 'Chỉnh sửa ngôn ngữ',
  'product.language.delete': 'Xóa',
  'product.language.language': 'Ngôn ngữ',
  'product.language.image': 'Hình ảnh sản phẩm',
  'product.language.success': 'Thành công',
  'product.language.fail': 'Thất bại',
  'product.language.confirmDelete': 'Bạn có chắc chắn muốn xóa?',
  'product.language.operator': 'Người vận hành',
  'product.language.operateTime': 'Thời gian vận hành',
  'product.stock.title': 'Quản lý kho',
  'product.stock.add': 'Thêm kho',
  'product.stock.edit': 'Chỉnh sửa kho',
  'product.stock.viewHistory': 'Xem lịch sử',
  'product.stock.available': 'Kho có sẵn',
  'product.stock.freeze': 'Kho đóng băng',
  'product.stock.total': 'Tổng kho',
  'product.stock.changeType': 'Loại thay đổi',
  'product.stock.changeAmount': 'Số lượng thay đổi',
  'product.stock.remark': 'Ghi chú',
  'product.stock.history': 'Lịch sử thay đổi',
  'product.stock.increase': 'Tăng',
  'product.stock.decrease': 'Giảm',
  'product.stock.success': 'Thành công',
  'product.stock.fail': 'Thất bại',
  'product.stock.recordNotFound': 'Không tìm thấy bản ghi',
  'product.stock.operator': 'Người vận hành',
  'product.stock.operateTime': 'Thời gian vận hành',
  'product.trade.title': 'Hồ sơ giao dịch',
  'product.trade.orderId': 'ID đổi',
  'product.trade.memberAccount': 'Tài khoản thành viên',
  'product.trade.type': 'Loại sản phẩm',
  'product.trade.name': 'Tên sản phẩm',
  'product.trade.currency': 'Tiền tệ',
  'product.trade.value': 'Giá trị sản phẩm',
  'product.trade.price': 'Điểm sản phẩm',
  'product.trade.quantity': 'Số lượng đổi',
  'product.trade.time': 'Thời gian đổi',
  'product.trade.vipLevel': 'Cấp VIP',
  'product.trade.success': 'Thành công',
  'product.trade.fail': 'Thất bại',
  'product.trade.export': 'Xuất',
  'product.trade.exportWarning': 'Vui lòng chọn phạm vi thời gian',
  'product.trade.exportLoading': 'Đang xuất dữ liệu...',
  'product.trade.exportSuccess': 'Xuất thành công',
  'product.trade.exportFail': 'Xuất thất bại'
};
